<div
  class="layout-wrapper"
  [ngClass]="{
    'p-input-filled': inputStyle === 'filled',
    'p-ripple-disabled': !ripple,
    'layout-menu-static': menuMode === menuModeEnum.Static,
    'layout-menu-overlay': menuMode === menuModeEnum.Overlay,
    'layout-menu-horizontal': menuMode === menuModeEnum.Horizontal,
    'layout-menu-slim': menuMode === menuModeEnum.Slim,
    'layout-menu-icons': menuMode === menuModeEnum.Icons,
    'layout-menu-active': menuActive,
    'layout-menu-mobile-active': mobileMenuActive,
    'layout-topbar-mobile-active': mobileTopbarActive,
    'layout-rightmenu-active': rightMenuActive,
    'layout-rtl': rtlDir$ | async,
  }"
  [class]="
    'layout-menu-' +
    (layoutMode === 'dark' ? 'dark' : 'gold') +
    ' layout-topbar-' +
    (layoutMode === 'dark' ? 'dark' : 'gold')
  "
  [style.--topBar-height]="contentOnly ? '0' : null"
>
  <ng-container *ngIf="!contentOnly" [class.fullscreen]="true">
    <app-topbar></app-topbar>

    <aside
      class="menu-wrapper"
      (click)="onMenuClick()"
      (keyup.enter)="onMenuClick()"
    >
      <div class="layout-menu-container">
        <app-menu></app-menu>
      </div>
    </aside>
    <app-config></app-config>
  </ng-container>

  <div class="layout-main">
    <div class="layout-content">
      <router-outlet></router-outlet>
    </div>
  </div>

  <app-help-and-documentation-trigger />
  <!--  Design Requested To Add bottom space to prevent help-and-documentation button -->
  <!--  from overlapping with the other important elements.-->
  <div class="h-[48px]"></div>

  <div *ngIf="mobileMenuActive" class="layout-mask modal-in"></div>
</div>
<p-toast key="bottom-right" position="bottom-right"></p-toast>

<svg width="0" height="0" class="hidden">
  <symbol id="Icon-umbrella" width="24" height="24" viewBox="0 0 24 24">
    <path
      d="M24.265 14.688a2.494 2.494 0 0 1 1.95 1.494h1.16a11.933 11.933 0 0 0-3.427-8.129 12.491 12.491 0 0 0-7.65-3.79 1.316 1.316 0 0 0-2.487-.006A11.59 11.59 0 0 0 3.375 15.963a1.332 1.332 0 0 0 .023.219h1.258a2.493 2.493 0 0 1 2.037-1.494A2.216 2.216 0 0 1 8.8 16.183h1.14a1.959 1.959 0 0 1 1.9-1.483 2 2 0 0 1 1.967 1.881v6.825c0 .537.006 1.39-.773 1.39a.833.833 0 0 1-.958-.923v-1.229H9.6v1.229a3.333 3.333 0 0 0 3.462 3.5 3.431 3.431 0 0 0 2.51-1.079 4.058 4.058 0 0 0 .779-2.89v-6.869c.115-1.488 1.379-1.829 2.417-1.829a2.4 2.4 0 0 1 2.181 1.477h1.183a2.247 2.247 0 0 1 2.133-1.495z"
      transform="translate(-3.375 -3.375)"
    />
  </symbol>
</svg>
